export default __webpack_public_path__ + "static/calipers-e64b6fb518877f6d3a04f9ea04d66177.png";